(function() {
    'use strict';
    /*
     * Copyright (c) 2015-2017 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .directive('ihhViewEditSelect', ihhViewEditSelect);

    /**
     * A directive for displaying an enum field as text in read mode and changing it to dropdown input in edit mode. Intended for
     * use with controllers that derive from {@link ihh-common-web.ViewEditCtrlBase}.
     * @ngdoc directive
     * @name ihh-view-edit-select
     * @memberOf ihh-common-web
     * @example
     * <ihh-view-edit-select
     *    control-id="some-id"
     *    edit-flag="isEdit"
     *    get="someGetFn"
     *    set="someGetFn"
     *    label="Color"
     *    values="['Red', 'Blue', 'Yellow']">
     * </ihh-view-edit-select>
     */
    function ihhViewEditSelect() {
        return {
            restrict: 'AE',
            transclude: true,
            scope: {
                /**
                 * The HTML id to use for the control and label, for accessibility.
                 * @ngdoc property
                 * @name control-id
                 * @memberOf ihh-common-web.ihh-view-edit-select
                 */
                controlId: '@',

                /**
                 * The scope variable used to track view and edit mode.
                 * @ngdoc property
                 * @name edit-flag
                 * @memberOf ihh-common-web.ihh-view-edit-select
                 */
                editFlag: '=',

                /**
                 * The text to display as a label.
                 * @ngdoc property
                 * @name label
                 * @memberOf ihh-common-web.ihh-view-edit-select
                 */
                label: '@',

                /**
                 * An expression for determining whether this element should be disabled.
                 * @ngdoc property
                 * @name disabled-if-exp
                 * @memberOf ihh-common-web.ihh-view-edit-select
                 */
                disabledIfExp: '=',

                /**
                 * The scope function used to get the selected value (in view or edit mode).
                 * @ngdoc property
                 * @name get
                 * @memberOf ihh-common-web.ihh-view-edit-select
                 */
                get: '=',

                /**
                 * The scope function used to set the selected value (only in edit mode).
                 * @ngdoc property
                 * @name set
                 * @memberOf ihh-common-web.ihh-view-edit-select
                 */
                set: '=',

                /**
                 * The scope variable used to get select values to display.
                 * @ngdoc property
                 * @name values
                 * @memberOf ihh-common-web.ihh-view-edit-select
                 */
                values: '=',

                /**
                 * The scope variable used to get select values to display by default
                 * @ngdoc property
                 * @name valuesDefaults
                 * @memberOf ihh-common-web.ihh-view-edit-select
                 */
                valuesDefaults: '=',

                /**
                 * An optional scope function used to convert from a select value to a string. Defaults to identity.
                 * @ngdoc property
                 * @name format-value
                 * @memberOf ihh-common-web.ihh-view-edit-select
                 */
                formatValue: '=',

                /**
                 * An optional scope function used to convert from a select value to a string. Defaults to identity.
                 * @ngdoc property
                 * @name containing-model-default
                 * @memberOf ihh-common-web.ihh-view-edit-select
                 */
                containingModelDefault: '=',

                /**
                 * An optional scope function used to convert from a select value to a string. Defaults to identity.
                 * @ngdoc property
                 * @name containing-model
                 * @memberOf ihh-common-web.ihh-view-edit-select
                 */
                containingModel: '=',

                /**
                 * An optional scope function used to convert from a select value to a string. Defaults to identity.
                 * @ngdoc property
                 * @name containing-form
                 * @memberOf ihh-common-web.ihh-view-edit-select
                 */
                containingForm: '=',

                /**
                 * The scope variable used to determine inline style
                 * @ngdoc property
                 * @name inline-style
                 * @memberOf ihh-common-web.ihh-view-edit-select
                 */
                inlineStyle: '='
            },
            templateUrl: 'view-edit/view-edit-select.tpl.html',
            controller: 'ihh.common-web.ViewEditSelectCtrl'
        };
    }
})();